import styled from '@emotion/styled'

export const KP11LinkCatalogCardWrapperStyle = styled.div`
  z-index: 1;
  width: 100%;
  // max-width: 40.25rem; /* 644px */
  opacity: 1;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  gap: 2rem; /* 32px */
  border: 1px solid #eceef1;
  border-radius: 0.75rem; /* 12px */
  padding: 2rem; /* 30px ~ fluid spacing */
  color: #000000;
  background: white;
  box-shadow: 0px 5px 5px -3px #00000033, 0px 3px 14px 2px #0000001f,
    0px 8px 10px 1px #00000024;

  /* 📱 Mobile adjustments */
  @media (max-width: 768px) {
    padding: 1rem;
    gap: 1.5rem;

    .catalog-card-header {
      flex-direction: column;
      align-items: flex-start;
      gap: 1rem;
    }

    .card-plan-item-wrap {
      flex-direction: column;
      .card-plan-item {
        max-width: 100%;
      }
    }
  }
`
export const CardPlanHeaderStyle = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  cursor: pointer;
  gap: 2rem;

  .card-heading {
    display: flex;
    align-items: center;
    gap: 1rem; /* 16px */
  }

  .card-icon {
    opacity: 1;
    border: 1px solid #d6d6d6;
    border-radius: 0.85rem !important; /* 6px */
    position: relative;
    img {
      width: 3.375rem; /* 54px */
      height: 3.625rem; /* 58px */
      border-radius: 0.75rem !important; /* 6px */
    }
  }

  .card-title-text {
    font-family: 'Montserrat', sans-serif;
    font-weight: 600;
    font-style: normal;
    font-size: clamp(1.25rem, 2vw, 1.75rem); /* 20px–28px */
    line-height: clamp(1.75rem, 2.5vw, 2.25rem); /* 28px–36px */
    letter-spacing: 0;
    color: #000000;
  }

  .action-btn {
    min-width: 6.25rem; /* 100px */
    height: 2rem; /* 32px */
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 0.25rem; /* 4px */
    padding: 0.5rem 1.5rem;
    background: #ff5000;
    font-family: 'Open Sans', sans-serif;
    font-weight: 600;
    font-size: clamp(0.75rem, 1vw, 0.8125rem); /* 12px–13px */
    line-height: 1rem; /* ~16px */
    letter-spacing: 0.03125rem; /* 0.5px */
    text-align: center;
    color: white;
    border: 1px solid #ff5000;
  }

  .action-btn.remove-btn {
    background: #ffffff;
    color: #ff5000;
    border: 1px solid #ff5000;
  }

  .action-btn:disabled {
    color: #ffffff;
    border: 1px solid #000000;
    background: #000000;
    opacity: 0.09;
  }
`
export const CardPlanBodyStyle = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem; /* 16px */
  width: 100%;

  .card-plan-subText {
    font-family: 'Open Sans', sans-serif;
    font-weight: 400;
    font-size: clamp(0.875rem, 1vw, 1rem); /* 14px–16px */
    line-height: 1.25rem; /* 20px */
    letter-spacing: 0;
  }

  .plan-item-price {
    font-family: 'Open Sans', sans-serif;
    font-weight: 300;
    font-size: clamp(1.5rem, 3vw, 2.25rem);
    line-height: 1;
    color: #231f20;
    padding: 0.25rem 0;
  }
`
export const CardPlanWebsiteUrlStyle = styled.div`
  padding: 25px 0 0;
`

export const CardPlanBillingDateWrapperStyle = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  gap: 8px;
  .tl-billing-label {
    font-family: 'Open Sans', sans-serif;
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;
    letter-spacing: 0;
    color: #808080;
  }
`
export const CardPlanDomainWrapperStyle = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  gap: 8px;
  .seo-domain-label {
    font-family: 'Open Sans', sans-serif;
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;
    letter-spacing: 0;
    .seo-domain-url {
      font-family: 'Open Sans', sans-serif;
      font-weight: 400;
      font-size: 14px;
      line-height: 20px;
      letter-spacing: 0;
      color: #057aff;
    }
  }
  .seo-domain-option {
  }
  .seo-domain-note {
    padding: 8px 12px;
    border: 1px solid #82bdff;
    border-radius: 4px;
    background: #e6f2ff;
    opacity: 1;
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
    gap: 8px;
    .seo-domain-note-icon {
      // width: 50px;
      // height: 20px;
      .note-info-icon {
        width: 50px;
        height: 20px;
      }
    }

    .seo-domain-note-text {
      font-family: 'Open Sans', sans-serif;
      font-weight: 400;
      font-size: 14px;
      line-height: 20px;
      letter-spacing: 0;
      color: #231f20;
    }
  }
`
export const IsExternalDomainRadioStyle = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  gap: 12px;
  .ed-radio-label-wrap {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    gap: 8px;
    color: #121212;
    cursor: pointer;
    .ed-radio-label {
      font-family: 'Open Sans', sans-serif;
      font-weight: 400;
      font-size: 14px;
      line-height: 20px;
      letter-spacing: 0;
      cursor: pointer;
    }
    .ed-radio-input.disabled {
      cursor: not-allowed;
    }
  }
  .ed-radio-label-wrap.disabled {
    color: #808080;
    cursor: not-allowed;
  }
`
export const IsBillingDateRadioStyle = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  gap: 12px;
  .bd-radio-label-wrap {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    gap: 8px;
    color: #121212;
    cursor: pointer;
    .bd-radio-label {
      font-family: 'Open Sans', sans-serif;
      font-weight: 400;
      font-size: 14px;
      line-height: 20px;
      letter-spacing: 0;
      cursor: pointer;
    }
    .bd-radio-input.disabled {
      cursor: not-allowed;
    }
  }
  .bd-radio-label-wrap.disabled {
    color: #808080;
    cursor: not-allowed;
  }
`
export const CardPlanAddToCartStyle = styled.div`
  width: 100%;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-wrap: wrap;
  gap: 1.5rem; /* 24px */
  padding: 0.5rem 0.75rem;
  color: #000000;
  background: #e8f6f3;
  border: 1px solid #8acfc2;
  border-radius: 0.25rem;
  img {
    width: 16px;
    height: 16px;
  }
`

export const KPStepperWrapperStyle = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  gap: 20px;
  // width: 50%;
`
export const StepperWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
  // width: 100%;
  width: 250px;
  font-family: 'Open Sans', sans-serif;
  color: #231f20;

  .stepper-label {
    // font-size: 14px;
    // color: #231f20;
    // font-weight: 500;
    margin: 0;
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
    font-family: 'Montserrat', sans-serif;
    font-weight: 600;
    font-size: clamp(1rem, 1.5vw, 1.125rem);
    line-height: 1.625rem;
    color: #231f20;
  }

  .stepper-box {
    display: flex;
    align-items: center;
    justify-content: space-between;
    // border-bottom: 1px solid #dcdcdc;
    border: 1px solid #dcdcdc;
    border-radius: 8px;
    padding: 6px 16px;
    // padding: 8px 12px;
    background: #fff;
    transition: border-color 0.2s ease, box-shadow 0.2s ease;
  }

  &:focus-within .stepper-box {
    border-color: #5378fc;
    box-shadow: 0 0 0 2px rgba(83, 120, 252, 0.1);
  }

  .step-btn {
    width: 32px;
    height: 32px;
    border-radius: 50%;
    background: #f2f6ff;
    color: #5378fc;
    font-size: 20px;
    font-weight: 600;
    border: none;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.15s ease;
  }

  .step-btn:hover:not(:disabled) {
    background: #5378fc;
    color: #fff;
  }

  .step-btn:disabled {
    opacity: 0.4;
    cursor: not-allowed;
  }

  .step-value {
    min-width: 40px;
    text-align: center;
    font-size: 16px;
    font-weight: 500;
  }

  .unit-label {
    font-size: 10px;
    color: #666;
    // margin-top: 2px;
  }

  &.disabled {
    opacity: 0.5;
    pointer-events: none;
  }
`
